import { IOrdenacao } from "../../SolicitacaoPlaca/interfaces/IOrdenacao";
import { IFiltrosLotesTerceiros } from "../interfaces/IFiltrosLotesTerceiros";

export const FILTROS_LOTES_TERCEIROS_VAZIOS: IFiltrosLotesTerceiros = {
  idLote: [],
  idFornecedor: null,
  idUsuario: null,
  periodoEnvio: null,
};

export const ORDENACAO_LOTES_TERCEIROS_PADRAO: IOrdenacao = {
  campo: "criadoEm",
  direcao: "DESC",
};
